import { Pipe, PipeTransform } from '@angular/core';
import * as countries from 'i18n-iso-countries';
import de from 'i18n-iso-countries/langs/de.json';

countries.registerLocale(de);

@Pipe({
  name: 'countryName'
})
export class CountryPipe implements PipeTransform {
  transform(value: string, lang: string = 'de'): string {
    if (!value) return '';
    return countries.getName(value, lang) || value;
  }
}